import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './lib/auth-context';
import { PomodoroProvider } from './lib/pomodoro';
import { Layout } from './components/Layout';
import Home from './pages/Home';
import ChapterPage from './pages/ChapterPage';
import ResourcePage from './pages/ResourcePage';
import ToolsPage from './pages/ToolsPage';
import AIPage from './pages/AIPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import NotFound from './pages/NotFound';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

export default function App() {
  return (
    <AuthProvider>
      <PomodoroProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/c/:courseId" element={<Home />} />
              <Route path="/ch/:chapterId" element={<ChapterPage />} />
              <Route path="/res/:resourceId" element={<ResourcePage />} />
              <Route path="/tools" element={<ToolsPage />} />
              <Route path="/ai" element={<AIPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/admin/*" element={<AdminPage />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </PomodoroProvider>
    </AuthProvider>
  );
}
